import SearchService from "services/search-service";
import DownloadService from "services/download-service";
import UserService from "services/user-service";

export const facebookLoginHandler = (resolve, reject, clientId) => {
  if (window.FB) {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          console.log("Logged in with Facebook:", response);
          checkLoginState(resolve, reject, clientId);
        } else {
          console.log("User cancelled login or did not fully authorize.");
          reject(new Error("Login cancelled or not authorized."));
        }
      },
      {
        scope: "public_profile,email,pages_show_list,pages_read_engagement,pages_read_user_content,business_management,read_insights,ads_management,ads_read,pages_messaging,instagram_basic,instagram_manage_insights,instagram_manage_comments,read_insights",
        auth_type: "rerequest"
      }
    );
  } else {
    console.error("Facebook SDK not loaded");
    reject(new Error("Facebook SDK not loaded"));
  }
};

const checkLoginState = (resolve, reject, clientId) => {
  window.FB.getLoginStatus(async (response) => {
    try {
      await statusChangeCallback(response, resolve, reject, clientId);
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

const statusChangeCallback = async (response, resolve, reject, clientId) => {
  if (response.status === "connected") {
    const fbSLAT = response.authResponse.accessToken;
    localStorage.setItem("fbSLAT", fbSLAT);

    const searchTerm = "Dummy"; // Example search term
    const platform = "Facebook";
    const combinedResults = await SearchService.searchAllPlatforms(searchTerm, platform);

    if (combinedResults && combinedResults.length > 0) {
      for (const result of combinedResults) {
        try {

          const profileData = {
            id: result.id,
            platform: result.platform,
            name: result.name,
            count: result.followers_count ?? result.subscribersCount ?? 0,
            creationDate: result.creationDate,
            profilePictureUrl: result.picture,
            link: result.link,
            verifiedStatus:
              result.verification_status === "verified" ||
              result.verification_status === "blue_verified",
            own: true,
            clientId: clientId, // Pass clientId to backend for WebSocket progress
          };

          // Download profile using the DownloadService
          await DownloadService.downloadProfile(result.platform, { profileData });
          console.log(`Successfully downloaded profile: ${result.name}`);
        } catch (error) {
          console.error(`Error downloading profile (${result.name}):`, error.message);
        }
      }
      localStorage.removeItem("fbSLAT");
    } else {
      console.log("No results found in combinedResults.");
      reject(new Error("No Facebook Pages found. Please check your permissions and ensure you have selected a page to connect."));
    }
  } else {
    console.log("User not authenticated");
  }
};
